class EventBus {
	list = {}

	constructor(options) {
		if (EventBus.instance) {
			return EventBus.instance
		}
		EventBus.instance = this

		const defaultOptions = {
			debug: false,
		}
		this.options = Object.assign(defaultOptions, options)
	}

	emit(event, eventObject = {}) {
		eventObject._name = event
		if (this.list[event]) {
			if (this.options.debug) {
				console.info(`${this.list[event].length} handler${this.list[event].length > 1 ? 's' : ''} called on event '${event}'`)
			}

			this.list[event].forEach((handlerObject) => {
				if (!handlerObject.handler) {
					console.warn(`Handler on ${event} is undefined`)
					return
				}
				handlerObject.handler(eventObject)

				if (handlerObject.once) {
					this.off(event, handlerObject.handler)
				}
			})
		} else {
			if (this.options.debug) {
				console.info(`0 handlers called on event '${event}'`)
			}
		}
	}

	on(event, handler, once = false) {
		if (this.list[event]) {
			this.list[event].push({ once: once, handler: handler })
		} else {
			this.list[event] = []
			this.list[event].push({ once: once, handler: handler })
		}
	}

	once(event, handler) {
		this.on(event, handler, true)
	}

	off(event, handler) {
		if (event != null) {
			if (handler != null) {
				if (this.list[event] && this.list[event].filter((eventObject) => eventObject.handler === handler).length) {
					let toRemove = this.list[event].filter((eventObject) => eventObject.handler === handler)[0]
					let index = this.list[event].indexOf(toRemove)
					if (index > -1) {
						this.list[event].splice(index, 1)
					}
				} else {
					console.warn(`Event ${event} cannot be unsubscribed - does not exist.`)
				}
			} else {
				this.list[event] = []
			}
		} else {
			this.list = {}
		}
	}
}

const eventBusInstance = new EventBus()
export { eventBusInstance as EventBus }

// ------------------------------------------------------------------------- //
/**
 *
 */
class SmplComponents {
	static instance
	//
	instances = []
	components = []
	// width;
	constructor() {
		if (SmplComponents.instance) {
			return SmplComponents.instance
		}
		SmplComponents.instance = this
	}

	setup(options) {
		this.options = options
		this.path = options.path
		this.componentsDef = options.components
	}

	createInstance(element, name, component) {
		component.prototype._name = name
		const instance = new component(element, { debug: this.options.debug })

		// Support multiple components on the same element
		if (!element.__components__) {
			element.__components__ = {}
		}
		element.__components__[name] = instance

		// Backward compatibility for old lookups
		element.__component__ = instance

		instance.prepare()
		return instance
	}

	async loadComponent(element, componentDef) {
		const result = await componentDef.loader()
		const ComponentClass = result.default || result

		const instance = this.createInstance(element, componentDef.name, ComponentClass)

		this.instances.push(instance)

		return { instance, element }
	}

	getComponentByElement(element, name) {
		if (!element) return null

		// New storage
		if (element.__components__) {
			if (!name) return element.__components__
			return element.__components__[name] || null
		}

		// Backward compatibility
		if (!name) return element.__component__ || null
		return element.__component__ && element.__component__._name === name ? element.__component__ : null
	}

	queryComponents(selector, context) {}

	// Destroy a component by element
	destroyElement(element) {
		const instances = this.getComponentByElement(element)

		if (!instances) return

		Object.values(instances).forEach((instance) => {
			this.destroyInstance(instance)
		})
	}

	// Destroy a component by instance
	destroyInstance(instance) {
		if (!instance) return

		const element = instance.getElement()
		instance.preUnmount()

		if (element.__components__) {
			delete element.__components__[instance._name]

			if (Object.keys(element.__components__).length === 0) {
				delete element.__components__
			}
		}

		// Backward compatibility cleanup
		if (element.__component__ === instance) {
			element.__component__ = null
		}

		// Prevent stale references
		this.instances = this.instances.filter((i) => i !== instance)
	}

	removeComponents(context) {
		if (!context) {
			context = document
		}

		this.components.forEach((component) => {
			context.querySelectorAll(`${component.selector}`).forEach((element) => {
				const instance = this.getComponentByElement(element, component.name)

				if (instance) {
					this.destroyInstance(instance)
				}

				if (this.options.debug) {
					console.info(`[SMPL-CMPNTS]: Component destroyed "${component.name}" selector(${component.selector})`)
				}
			})
		})
	}

	getInstancesArrayByName(componentName) {
		return this.instances.filter((instance) => instance._name === componentName)
	}

	loadComponents(context, callback) {
		if (!this.components.length) {
			console.log('No components defined')
			return
		}
		if (!context) {
			context = document
		}

		let promises = []

		this.components.forEach((component) => {
			context.querySelectorAll(`${component.selector}`).forEach((element) => {
				const instance = this.getComponentByElement(element, component.name)

				if (instance) {
					if (this.options.debug) {
						console.info(`[SMPL-CMPNTS]: Skipped loading "${component.name}" selector(${component.selector}) already loaded`)
					}
					return
				}

				let loadPromise = this.loadComponent(element, component)
				promises.push(loadPromise)

				if (this.options.debug) {
					console.info(`[SMPL-CMPNTS]: Start loading "${component.name}" selector(${component.selector})`)
				}
			})
		})

		if (promises.length > 0) {
			Promise.all(promises).then((loadedModules) => {
				loadedModules.forEach(({ instance }) => {
					if (this.options.debug) {
						console.info(`[SMPL-CMPNTS]: Mounted "${instance._name}"`)
					}
					instance.preMount()
				})

				if (typeof callback === 'function') {
					callback()
				}
			})
		} else if (typeof callback === 'function') {
			callback()
		}
	}

	registerComponents(components) {
		components.forEach((component) => {
			if (this.options.debug) {
				console.info(`[SMPL-CMPNTS]: Registered "${component.name}" (${component.selector})`)
			}

			this.components.push(component)
		})
	}
	//   findElements() {
	//     // create a list of selectors

	//     // create a list of selectors from an array of objects which has a selector property
	//     const selectors = this.componentsDef.map((component) => {
	//       return component.selector;
	//     });

	//     console.log(selectors);
	//   }
	init() {
		this.registerComponents(this.componentsDef)
		this.loadComponents()
	}

	//
	getInstances() {
		return this.instances
	}
}

// const ComponentsManager = new SmplComponents();
const smplComponentsInstance = new SmplComponents()
export { smplComponentsInstance as ComponentsManager }

// ------------------------------------------------------------------------- //

export class Component {
	constructor(element, options) {
		this.element = element

		this.element = element
		this.element['__component__'] = this

		this.options = options || {}

		this.eventBus = new EventBus(this.options)

		// this.element['__gia_component__'] = this;
		// this._ref = {};
		// this._options = options || {};
		// this._state = {};
	}

	getElement() {
		return this.element
	}

	prepare() {}

	mount() {
		console.warn(`Mount method not implemented: ${this._name}`)
	}

	unmount() {
		console.warn(`Unmount method not implemented: ${this._name}`)
	}

	//
	preMount() {
		this.mount()
	}
	preUnmount() {
		this.unmount()
	}
}
